import React from "react";
import { Route, Navigate, Outlet } from "react-router-dom";

export const PrivateRoute = () => {
  const auth = JSON.parse(localStorage.getItem("user")); // determine if authorized, from context or however you're doing it
  // If authorized, return an outlet that will render child elements
  // If not, return element that will navigate to login page
  return auth && auth.accessToken ? <Outlet /> : <Navigate to="/" />;
};
